import { render, staticRenderFns } from "./CotPropostaAccessoProrogheListComponent.vue?vue&type=template&id=bf4b15a6"
import script from "./CotPropostaAccessoProrogheListComponent.vue?vue&type=script&lang=js"
export * from "./CotPropostaAccessoProrogheListComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports